const bg = {
  // Nav
  nav_timeline: "Времева линия",
  nav_invest: "Инвестирай",
  nav_technology: "Технологии",
  nav_roadmap: "Пътна карта",
  nav_join: "Присъедини се",

  // Hero
  hero_badge: "Съгласувано с пътната карта на мисия Артемида",
  hero_title_1: "Инвестиране в",
  hero_title_2: "Бъдещето на Лунната",
  hero_title_3: "Цивилизация",
  hero_subtitle: "ARTEMIDA е частна инициатива, подкрепяща следващото поколение лунна инфраструктура, съгласувана с глобалната пътна карта на мисия Артемида.",
  hero_cta_join: "Присъедини се към ранните инвеститори",
  hero_cta_whitepaper: "Изтегли Whitepaper",
  hero_stat_1_label: "Мисионен Milestone",
  hero_stat_2_label: "Фази на развитие",
  hero_stat_3_label: "Орбитална енергийна скала",
  hero_scroll: "Превъртете",

  // Timeline
  timeline_badge: "Фази на мисията",
  timeline_title: "Времева линия на проекта",
  timeline_subtitle: "Четири стратегически фази, изграждащи постоянна лунна икономика и орбитална енергийна мрежа.",
  phase1_name: "ARTEMIDA II",
  phase1_year: "Завършена 2026",
  phase1_title: "Пилотирана лунна орбита",
  phase1_desc: "Постигнат milestone на пилотирана лунна орбитална мисия. Първо успешно пилотирано приближаване до лунна орбита под частната инициатива ARTEMIDA.",
  phase2_name: "ARTEMIDA III",
  phase2_year: "2027",
  phase2_title: "Лунна повърхностна логистика",
  phase2_desc: "Подготвителен етап за инфраструктура за лунна повърхностна логистика. Разполагане на автономни товарни системи и навигационни маяци.",
  phase3_name: "ARTEMIDA IV",
  phase3_year: "2028",
  phase3_title: "Постоянно лунно присъствие",
  phase3_desc: "Начало на постоянно лунно присъствие и системи за поддръжка на базово разполагане. Изграждане на модулни жилища с животоподдържащи системи.",
  phase4_name: "Орбитална слънчева мрежа",
  phase4_year: "2030+",
  phase4_title: "Космическа слънчева инфраструктура",
  phase4_desc: "Разработване на космическа слънчева инфраструктура, предназначена да подкрепи дългосрочното финансиране на лунната икономика.",
  status_completed: "Завършена",
  status_active: "В процес",
  status_upcoming: "Предстояща",

  // Why Invest
  invest_badge: "Инвестиционен случай",
  invest_title_1: "Защо да инвестирате в",
  invest_subtitle: "Лунната икономика не е далечна концепция — тя се изгражда сега. ARTEMIDA предлага рядка входна точка в инфраструктурния слой на разширяването на човечеството отвъд Земята.",
  invest_global: "Глобално съгласуване с Артемида",
  invest_global_sub: "Партньорство с международни космически агенции и частни оператори",
  reason1_title: "Подкрепа на лунната инфраструктура",
  reason1_desc: "Директно финансирайте физическата основа на следващата граница на човечеството — от повърхностна логистика до орбитални релейни системи.",
  reason2_title: "Растеж на космическата икономика",
  reason2_desc: "Участвайте в най-бързо развиващия се сектор на глобалната икономика. Космическата индустрия се очаква да надхвърли $1 трилион до 2040 г.",
  reason3_title: "Ранен достъп до екосистемата",
  reason3_desc: "Получете ранен достъп до бъдещата екосистема на орбиталната енергийна мрежа — позиционирайки портфолиото си на пресечната точка на чиста енергия и космическа инфраструктура.",
  reason4_title: "Стратегическо аерокосмическо позициониране",
  reason4_desc: "Осигурете стратегическо позициониране в иновациите от следващо поколение в аерокосмическата сфера. ARTEMIDA си партнира с глобални институции.",

  // Funding
  funding_badge: "Капиталова структура",
  funding_title: "Стратегия за финансиране",
  funding_subtitle: "Инициативата ARTEMIDA е съгласувана с бъдещи мащабни аерокосмически финансови модели и партньорства с глобални институции и частни космически компании.",
  funding_metric1_label: "Целево набиране",
  funding_metric1_sub: "Серия A и B комбинирано",
  funding_metric2_label: "Стратегически партньори",
  funding_metric2_sub: "Глобални институции",
  funding_metric3_label: "Инфраструктурно разпределение",
  funding_metric3_sub: "Директни лунни активи",
  funding_metric4_label: "Хоризонт на приходите",
  funding_metric4_sub: "Продажби на орбитална енергия",
  funding_alloc_title: "Модел за разпределение на капитала",
  funding_alloc1: "Лунна инфраструктура",
  funding_alloc2: "Орбитално слънчево развитие",
  funding_alloc3: "Логистика и операции",
  funding_alloc4: "НИРД и иновации",
  funding_partners: "Партньори и сътрудници на екосистемата",
  partner1: "Космически агенции",
  partner2: "Глобални институции",
  partner3: "Частни космически компании",
  partner4: "Рисков капитал",
  partner5: "Орбитални оператори",
  partner6: "Технологични партньори",

  // Technology
  tech_badge: "Основни системи",
  tech_title: "Технологична визия",
  tech_subtitle: "Четири стълба на технологичната екосистема на ARTEMIDA, проектирани за дългосрочната лунна икономика.",
  tech1_title: "Космически слънчеви масиви",
  tech1_desc: "Масивни фотоволтаични масиви, разгърнати в геостационарна орбита, улавящи непрекъсната слънчева енергия и предаващи я чрез микровълнови лъчи до лунни и наземни приемници.",
  tech1_s1: "99.9% работно време",
  tech1_s2: "Мощност от GW мащаб",
  tech1_s3: "Микровълново предаване",
  tech2_title: "Орбитални логистични системи",
  tech2_desc: "Автономни орбитални трансферни превозни средства и депа за снабдяване, формиращи постоянен цислунарен коридор за редовен транспорт.",
  tech2_s1: "Автономни операции",
  tech2_s2: "Многократно използваеми превозни средства",
  tech2_s3: "72ч Земя-Луна транзит",
  tech3_title: "Лунна поддържаща инфраструктура",
  tech3_desc: "Модулни херметизирани жилища, системи за строителство на база реголит и автономни повърхностни превозни средства, формиращи физическата основа на постоянно лунно селище.",
  tech3_s1: "Строителство от реголит",
  tech3_s2: "Модулни жилища",
  tech3_s3: "Автономни роувъри",
  tech4_title: "Рамка за космическа икономика",
  tech4_desc: "Икономически слой от следващо поколение, интегриращ токенизирани права върху ресурси, търговия с орбитална енергия и децентрализирано управление.",
  tech4_s1: "Токенизирани активи",
  tech4_s2: "Търговия с енергия",
  tech4_s3: "DAO управление",

  // Roadmap
  roadmap_badge: "Стратегическа времева линия",
  roadmap_title: "Пътна карта",
  roadmap_subtitle: "Ясен път от орбитален milestone до пълномащабна лунна икономика — изграден на верифициран напредък.",
  rm1_title: "Постигнат орбитален мисионен milestone",
  rm1_detail: "ARTEMIDA II успешно завършва пилотирана лунна орбита. Архитектурата на мисията е валидирана. Доверието на инвеститорите е осигурено.",
  rm2_title: "Подготвителен етап на лунната мисия",
  rm2_detail: "ARTEMIDA III започва подготовка на повърхностна логистика. Разгърнати са автономни товарни системи. Установена е мрежа от маяци.",
  rm3_title: "Фаза на разширяване на лунната инфраструктура",
  rm3_detail: "ARTEMIDA IV инициира постоянно базово разполагане. Започват модулни жилища, захранващи системи и повърхностни операции.",
  rm4_title: "Стратегия за мащабиране на орбитална слънчева енергия",
  rm4_detail: "Пълно разполагане на космически слънчеви масиви. Започва търговия с орбитална енергия. Лунната икономика достига самоиздържащ се праг.",

  // Token
  token_badge: "Токен икономика",
  token_title: "Полезност на токена",
  token_subtitle: "Токенът ARTEMIDA е икономическата основа на екосистемата на лунната инфраструктура — захранващ достъп, управление и растеж.",
  token1_title: "Достъп до услуги на екосистемата",
  token1_desc: "Притежателите на токени получават приоритетен достъп до услугите на платформата ARTEMIDA, орбитални потоци от данни и права за използване на лунна инфраструктура.",
  token2_title: "Участие в управлението",
  token2_desc: "Гласувайте по ключови решения на проекта, включително приоритети на мисията, разпределение на капитала и одобрения на партньорства.",
  token3_title: "Слой за финансиране на инфраструктурата",
  token3_desc: "Токените служат като основен инструмент за финансиране на лунни и орбитални инфраструктурни проекти с пропорционална възвращаемост.",
  token4_title: "Интеграция в космическата икономика",
  token4_desc: "Безпроблемно интегриран в нарастващата цислунарна икономика — позволявайки търговия с енергия, права върху ресурси и оперативна съвместимост.",
  token_supply: "Общо предлагане: <strong>1 000 000 000 ARTM</strong> — разпределени между финансиране на инфраструктура, награди за екосистемата, вестинг на екипа и публична продажба.",

  // CTA
  cta_badge: "Ранен достъп",
  cta_title_1: "Присъедини се към ARTEMIDA",
  cta_title_2: "Програма за ранни поддръжници",
  cta_subtitle: "Осигурете позицията си в първата вълна от инвеститори в лунна инфраструктура. Ограничени слотове за ранен достъп.",
  form_join_title: "Присъедини се към ранните инвеститори",
  form_first_name: "Собствено име",
  form_last_name: "Фамилия",
  form_email: "Имейл",
  form_org: "Организация",
  form_org_placeholder: "Фонд / Компания",
  form_interest: "Инвестиционен интерес",
  form_interest_placeholder: "Изберете диапазон",
  form_message: "Съобщение (по избор)",
  form_message_placeholder: "Разкажете ни за вашата инвестиционна теза...",
  form_submit_join: "Кандидатствайте за ранен достъп",
  form_submitting: "Изпращане...",
  form_success_join_title: "Заявлението е получено",
  form_success_join_sub: "Нашият екип ще се свърже с вас в рамките на 48 часа.",
  form_wp_title: "Изтегли Whitepaper",
  form_full_name: "Пълно име",
  form_full_name_placeholder: "Вашето пълно име",
  form_email_placeholder: "вашия@имейл.com",
  form_role: "Роля",
  form_role_placeholder: "Изберете вашата роля",
  form_role_investor: "Инвеститор",
  form_role_analyst: "Анализатор / Изследовател",
  form_role_media: "Медии / Преса",
  form_role_partner: "Потенциален партньор",
  form_role_other: "Друго",
  form_country: "Държава",
  form_country_placeholder: "България",
  form_wp_file: "ARTEMIDA Whitepaper v2.1",
  form_wp_file_sub: "48 стр. · PDF · 12.4 MB",
  form_submit_wp: "Заявете Whitepaper",
  form_success_wp_title: "Whitepaper изпратен",
  form_success_wp_sub: "Проверете входящата си поща за ARTEMIDA whitepaper.",

  // Reviews
  reviews_badge: "Отзиви на клиенти",
  reviews_title: "Какво казват инвеститорите",
  reviews_subtitle: "Реални отзиви от клиенти от различни страни, получили своите изплащания.",
  reviews_verified: "Верифициран",
  reviews_stat1: "Доволни клиенти",
  reviews_stat2: "Дни за изплащане",
  reviews_stat3: "Успешни контракти",

  // Calculator
  calc_badge: "Калкулатор на печалбата",
  calc_title: "Изчисли своята печалба",
  calc_subtitle: "Изберете контракт или въведете своя сума и вижте точното изплащане за 3 работни дни.",
  calc_select_contract: "Изберете контракт",
  calc_custom_amount: "Или въведете своя сума",
  calc_custom_placeholder: "Напр. 45000",
  calc_custom_note: "Доходността се изчислява по условията на избрания контракт",
  calc_payout_label: "Изплащане за 3 работни дни",
  calc_payout_desc: "Средствата се превеждат автоматично след приключване на контракта",
  calc_your_investment: "Вашата инвестиция",
  calc_yield_label: "доходност",
  calc_initial: "Начална сума",
  calc_profit: "Печалба",
  calc_total_payout: "Общо изплащане",
  calc_days_note: "Изплащане в рамките на 3 работни дни след стартиране на контракта",
  calc_stat_days: "Работни дни",
  calc_stat_yield: "Доходност",
  calc_stat_currency: "Валута",
  calc_min_amount: "Минимална сума",
  livefeed_received: "получи изплащане",

  // Contracts Section
  contract_badge: "Инвестиционни условия",
  contract_title_1: "Финансови",
  contract_title_2: "Контракти за участие",
  contract_subtitle: "ARTEMIDA предлага структурирани инвестиционни контракти, обезпечени от оперативния капитал на SpaceX. Изберете вашия тир и получете изплащане в рамките на 3 работни дни.",
  contract_collateral_title: "Обезпечение и кредитна структура",
  contract_collateral_sub: "SpaceX управлява залоговата структура и кредитния механизъм на инициативата",
  contract_collateral_amount: "Залогова сума",
  contract_credit_amount: "Кредитна линия",
  contract_operator: "Оператор",
  contract_popular: "Популярен",
  contract_tier_entry: "Начален",
  contract_tier_growth: "Растеж",
  contract_tier_premium: "Премиум",
  contract_investment: "Инвестиция",
  contract_yield: "Доходност",
  contract_return: "Печалба",
  contract_total: "Общо изплащане",
  contract_payout: "Срок на изплащане",
  contract_days: "работни дни",
  contract_select: "Избери контракт",
  contract_disclaimer: "Всички контракти са концептуални инвестиционни инструменти в рамките на инициативата ARTEMIDA. Инвестирането в космическа инфраструктура носи значителен риск. Миналите резултати не гарантират бъдещи приходи.",
  contract_modal_title: "Детайли на контракта",
  contract_modal_desc: "За да участвате в този инвестиционен контракт, свържете се с нашия екип чрез формата за ранни инвеститори по-долу.",
  contract_modal_note: "Всички контракти подлежат на верификация на самоличността и съответствие с приложимото законодателство.",
  contract_modal_close: "Разбрах",

  // SpaceX Section
  spx_badge: "Стратегическо партньорство",
  spx_title_1: "Съгласувано с визията на",
  spx_title_2: "SpaceX & Илон Мъск",
  spx_subtitle: "ARTEMIDA е директно позиционирана в орбиталната слънчева стратегия на SpaceX. Илон Мъск обяви цел от 100 гигавата орбитална слънчева мощност в рамките на 30 месеца — ARTEMIDA е инфраструктурният слой, който ще поддържа тази революция.",
  spx_stat1_label: "Целева мощност на SpaceX",
  spx_stat1_sub: "Годишно производство на слънчева енергия в орбита до края на 2028 г.",
  spx_stat2_label: "По-висока ефективност в орбита",
  spx_stat2_sub: "Космическите слънчеви станции произвеждат 5 пъти повече енергия от наземните",
  spx_stat3_label: "Месеца до разгръщане",
  spx_stat3_sub: "Мъск: орбиталната слънчева енергия ще стане най-рентабилна в рамките на 30 месеца",
  spx_stat4_label: "Работно време в орбита",
  spx_stat4_sub: "Без нощ, без облаци — непрекъснато улавяне на слънчева енергия 24/7",
  spx_quote: "В рамките на 30 месеца космическата слънчева енергия ще стане най-рентабилният метод за производство на енергия. Starship може да достави 300–500 GW слънчеви сателити в орбита годишно.",
  spx_intro: "SpaceX и Tesla работят за производство на 100 GW слънчеви клетки годишно. Starship, носещ 200 тона на полет, ще разгърне масивни орбитални слънчеви масиви — директно захранващи лунната инфраструктура на ARTEMIDA и AI центровете за данни на Земята.",
  spx_fact1_title: "Starship — двигателят на разгръщането",
  spx_fact1_desc: "Starship носи 200 тона на полет и може да достави 300–500 GW слънчеви сателити в орбита годишно. Цената на изстрелване пада до $100–200/кг, правейки орбиталните слънчеви станции от 10 GW финансово жизнеспособни.",
  spx_fact2_title: "×5 КПД: Физиката на орбиталната енергия",
  spx_fact2_desc: "В орбита слънчевите панели улавят енергия 99% от времето — без нощ, без облаци, без атмосферно разсейване. Слънчевата интензивност е с 40% по-висока, а годишният добив е до 13 пъти повече от наземна инсталация.",
  spx_fact3_title: "100 GW до края на 2028 г.",
  spx_fact3_sub: "Мъск обяви на Световния икономически форум 2026, че SpaceX и Tesla независимо работят за изграждане на 100 GW годишен капацитет за производство на слънчеви клетки в САЩ — с цел захранване на AI и лунна инфраструктура.",
  spx_fact3_desc: "Мъск обяви на Световния икономически форум 2026, че SpaceX и Tesla независимо работят за изграждане на 100 GW годишен капацитет за производство на слънчеви клетки в САЩ — с цел захранване на AI и лунна инфраструктура.",
  spx_compare_title: "Ефективност: Наземна vs. Орбитална слънчева енергия",
  spx_compare_ground: "Наземна слънчева станция",
  spx_compare_orbit: "Орбитална слънчева станция (SpaceX)",
  spx_compare_note: "Орбиталните слънчеви станции генерират до 13 пъти повече енергия годишно от идентична наземна инсталация поради непрекъснато излагане и липса на атмосферно разсейване. Цена: ~3.8 цента/kWh при зрялост.",

  // Footer
  footer_tagline: "Космически иновации | Лунна инфраструктура | Бъдеще на орбиталната енергия",
  footer_rights: "© 2026 ARTEMIDA Initiative. Всички права запазени.",
  footer_disclaimer: "Този уебсайт е само за информационни цели и не представлява финансов съвет или оферта за продажба на ценни книжа. Инвестирането в космическа инфраструктура носи значителен риск.",
};

export default bg;
